import { HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Skeleton, Spacer } from 'native-base';
import React from 'react';

export const Mobile: React.FC = () => {
  return (
    <VStack width="full" space={Spacing['inline.nano']} px={Spacing['inline.xxxs']}>
      <HStack alignItems="center" justifyContent="space-between" flex={1}>
        <Skeleton
          w="30%"
          h={Typography['fontsize.md']}
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
        />
        <Skeleton
          w="25%"
          h={Typography['fontsize.md']}
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
        />
      </HStack>
      <HStack alignItems="center" justifyContent="space-between" flex={1}>
        <Skeleton
          w="30%"
          h={Typography['fontsize.md']}
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
        />
        <Skeleton
          w="25%"
          h={Typography['fontsize.md']}
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
        />
      </HStack>
      <HStack alignItems="center" justifyContent="space-between" flex={1}>
        <Skeleton
          w="30%"
          h={Typography['fontsize.md']}
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
        />
        <Skeleton
          w="25%"
          h={Typography['fontsize.md']}
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
        />
      </HStack>
      <HStack alignItems="center" justifyContent="space-between" flex={1}>
        <Skeleton
          w="30%"
          h={Typography['fontsize.md']}
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
        />
        <Skeleton
          w="25%"
          h={Typography['fontsize.md']}
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
        />
      </HStack>
      <HStack alignItems={'center'} justifyContent={'space-between'} flex={1}>
        <Spacer />
        <Skeleton
          w="30%"
          h={Typography['fontsize.md']}
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
        />
      </HStack>
    </VStack>
  );
};
